
  import {Component, Vue} from 'vue-property-decorator';

  @Component(
    {
      name: 'catalog-product-simple'
    }
  )

  export default class extends Vue {

  }
